<template>
  <div :class="$style.slide">
    <div :class="$style.image">
      <base-image :image="image" :sizes="sizes" />
    </div>
    <div :class="$style.info">
      <div :class="$style['image-title']">{{ image.title }}</div>
      <div :class="$style['image-size']">{{ image.size }}</div>
      <div :class="$style['image-material']">{{ image.material }}</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    BaseImage: () => import('@/components/base-image')
  },
  props: {
    image: {
      type: Object,
      required: true
    }
  },
  computed: {
    isPortrait() {
      return this.image.ratio < 1 ? true : false
    },
    sizes() {
      if (this.isPortrait) {
        return '(min-aspect-ratio: 3/2) 30vw, (min-aspect-ratio: 1/1) 50vw, 100vw'
      } else {
        return '(min-aspect-ratio: 3/2) 60vw, 100vw'
      }
    }
  }
}
</script>

<style lang="scss" module>
.slide {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  @media (min-aspect-ratio: 3/2) {
    flex-direction: row-reverse;
  }
}

.image {
  flex: 1 1 auto;
  width: 100%;
  height: 100%;
  min-height: 1%; // Workaround to make scaling based on height working
  padding: 0 var(--gutter);

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (min-aspect-ratio: 3/2) {
    padding: 0;
  }
}

.info {
  @extend %fs-small;
  position: relative;
  z-index: 3;
  padding: var(--gutter);

  @media (min-aspect-ratio: 3/2) {
    align-self: flex-end;
    min-width: 20vw;
  }
}
</style>
